import { Editor, TLShape, Vec2d, pointInPolygon } from '@tldraw/tldraw'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { getContentBounds } from 'components/VisualStudioPlayground/Shapes/MaskShape/helpers'
import { getMaskingShapeId } from 'components/VisualStudioPlayground/VisualEditor/helpers'

/**
 * Returns the shape that was hit on canvas pointer down.
 * If the masking shape is hit, it will return the masking shape.
 * Otherwise, it will return undefined.
 */
export function getHitShapeOnCanvasPointerDown(editor: Editor): TLShape | undefined {
  const {
    inputs: { currentPagePoint },
  } = editor

  const maskingShapeId = getMaskingShapeId(editor)
  if (maskingShapeId) {
    const maskingShape = editor.getShape<MaskShape>(maskingShapeId)
    if (maskingShape) {
      const parent = editor.getShapeParent(maskingShapeId)
      const parentPosition = parent ? new Vec2d(parent.x, parent.y) : new Vec2d(0, 0)
      const { x, y, w, h } = getContentBounds(maskingShape)
      const x2 = x + w
      const y2 = y + h
      const points = [
        { x, y },
        { x: x2, y },
        { x: x2, y: y2 },
        { x, y: y2 },
      ].map((p) => Vec2d.From(p).rotWith({ x, y }, maskingShape.rotation).add(parentPosition))

      if (pointInPolygon(currentPagePoint, points)) {
        return maskingShape
      }
    }
  }
}
